import { render, staticRenderFns } from "./accommodation.vue?vue&type=template&id=d3715e04&scoped=true"
import script from "./accommodation.vue?vue&type=script&lang=js"
export * from "./accommodation.vue?vue&type=script&lang=js"
import style0 from "./accommodation.vue?vue&type=style&index=0&id=d3715e04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3715e04",
  null
  
)

export default component.exports